const ACTIVE_ADMIN_PAGE_KEY = "agrogrid:admin:active-page";
const ADMIN_PAGE_STATE_PREFIX = "agrogrid:admin:page-state:";

const canUseSessionStorage = () => typeof window !== "undefined" && Boolean(window.sessionStorage);
const stateKey = (pathname) => `${ADMIN_PAGE_STATE_PREFIX}${pathname}`;

export const readAdminPageState = (pathname, defaults = {}, inactiveDefaults = defaults) => {
  if (!canUseSessionStorage()) return defaults;
  const activePath = window.sessionStorage.getItem(ACTIVE_ADMIN_PAGE_KEY);
  if (activePath && activePath !== pathname) return inactiveDefaults;
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(stateKey(pathname)) || "null");
    return stored && typeof stored === "object" ? { ...defaults, ...stored } : defaults;
  } catch {
    return defaults;
  }
};

export const saveAdminPageState = (pathname, state) => {
  if (!canUseSessionStorage()) return;
  window.sessionStorage.setItem(stateKey(pathname), JSON.stringify(state));
};

export const activateAdminPageState = (pathname) => {
  if (!canUseSessionStorage()) return;
  const previousPath = window.sessionStorage.getItem(ACTIVE_ADMIN_PAGE_KEY);
  if (previousPath && previousPath !== pathname) {
    window.sessionStorage.removeItem(stateKey(previousPath));
  }
  window.sessionStorage.setItem(ACTIVE_ADMIN_PAGE_KEY, pathname);
};
